
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"48","height":"48","viewBox":"0 0 48 48","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M41.595 35.5c1.153 2-.295 4.5-2.599 4.5H9.003c-2.308 0-3.75-2.503-2.598-4.5L21.4 9.5c1.155-2.002 4.045-1.998 5.198 0l14.996 26zM24 30.126a2.875 2.875 0 100 5.75 2.875 2.875 0 000-5.75zm-2.73-10.334l.464 8.5a.75.75 0 00.749.709h3.034a.75.75 0 00.749-.71l.464-8.5a.75.75 0 00-.75-.79h-3.96a.75.75 0 00-.75.79z","fill":"#535353"}})])
          )
        }
      }
    